import { defineStore } from 'pinia';
import types from '@/types';
import ContractorService from '@/services/ContractorService';

const useContractorService = new ContractorService();

const useContractorStore = defineStore('contractor', {
  state: () => ({
    contractor: null,
    isLoading: false,
    isInitialized: false,
  }),
  getters: {
    isContractor: (state) => state.contractor !== null && state.contractor !== 'loaded',
    hasContractorData: (state) => typeof state.contractor === 'object' && state.contractor !== null,
    contractorNotFound: (state) => state.contractor === 'loaded',
  },
  actions: {
    [types.RESET_CONTRACTOR_STATE]() {
      this.contractor = null;
      this.isLoading = false;
      this.isInitialized = false;
    },
    async [types.GET_CONTRACTOR]() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        this.contractor = await useContractorService.get_contractor_info();
      } catch (error) {
        if (error.response?.data?.detail) {
          this.contractor = 'loaded';
        }
      } finally {
        this.isLoading = false;
        this.isInitialized = true;
      }
    },
    async [types.GET_CONTRACTOR_EMPLOYEES](expiresOn = null, page = 1, pageSize = 10) {
      try {
        const response = await useContractorService.get_contractor_employees(
          this.contractor.user_id,
          expiresOn,
          page,
          pageSize,
        );

        return response;
      } catch (error) {
        return error.response?.data?.detail || null;
      }
    },
  },
});

export default useContractorStore;
